'use client'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, FreeMode, Mousewheel } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination' // 分页器样式

export interface SwiperBoxProps {
  data: {
    list: any[]
    configuration?: any
  }
  id: string
  className?: string
  isHalf?: boolean
  breakpoints?: Record<number, Object>
  Slide: React.ComponentType<{ data: any; configuration?: any }>
  /** 自定义 pagination 样式类名 */
  paginationClassName?: string
}

const SwiperBox = React.forwardRef<HTMLDivElement, SwiperBoxProps>(
  ({ data, Slide, id, isHalf, paginationClassName }, ref) => {
    return (
      <Swiper
        freeMode={true}
        mousewheel={{
          forceToAxis: true,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: false,
          el: `.swiper-pagination-${id}`,
        }}
        className={`!overflow-visible ${paginationClassName || ''}`}
        modules={[FreeMode, Mousewheel, Pagination]}
        breakpoints={{
          0: {
            spaceBetween: 16,
            freeMode: false,
            slidesPerView: isHalf ? 2 : 1,
            slidesPerGroup: 1,
          },
          376: {
            spaceBetween: 16,
            freeMode: false,
            slidesPerView: isHalf ? 2 : 1,
            slidesPerGroup: 1,
          },
          767: {
            spaceBetween: 16,
            freeMode: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1441: {
            spaceBetween: 16,
            freeMode: false,
            slidesPerView: Math.min(6, data?.list?.length),
            slidesPerGroup: Math.min(6, data?.list?.length),
          },
        }}
      >
        {data?.list?.map((item, jIndex) => (
          <SwiperSlide key={id + 'SwiperSlide' + jIndex} className="!h-[unset]">
            <Slide data={item} configuration={{ ...data?.configuration, index: jIndex }} />
          </SwiperSlide>
        ))}
        <div className={`swiper-pagination-${id} swiper-pagination`} />
      </Swiper>
    )
  }
)

SwiperBox.displayName = 'SwiperBox'

export default SwiperBox
